module.exports = __webpack_public_path__ + "static/media/dashboard-icon.b1f54fde.svg";